// extracted by mini-css-extract-plugin
export default {"title":"ux_sk","message":"ux_cA"};